// Tiny icon set — inline SVG avoids font/Unicode rendering inconsistency
// across iOS/macOS/Linux/Windows.

interface IconProps {
  className?: string;
  "aria-hidden"?: boolean;
}

export const Icon = {
  Lock: (p: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={p.className ?? "w-5 h-5"}
      aria-hidden={p["aria-hidden"] ?? true}
    >
      <rect x="4" y="11" width="16" height="9" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  ),
  Flag: (p: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={p.className ?? "w-5 h-5"}
      aria-hidden={p["aria-hidden"] ?? true}
    >
      <path d="M5 3v18" />
      <path d="M5 3h13l-2 4 2 4H5" />
    </svg>
  ),
  Check: (p: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={p.className ?? "w-3.5 h-3.5"}
      aria-hidden={p["aria-hidden"] ?? true}
    >
      <path d="M5 12l5 5L20 7" />
    </svg>
  ),
  Plus: (p: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={p.className ?? "w-5 h-5"}
      aria-hidden={p["aria-hidden"] ?? true}
    >
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  Backspace: (p: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={p.className ?? "w-6 h-6"}
      aria-hidden={p["aria-hidden"] ?? true}
    >
      <path d="M21 5H8l-6 7 6 7h13a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z" />
      <path d="M18 9l-6 6M12 9l6 6" />
    </svg>
  ),
  Search: (p: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={p.className ?? "w-4 h-4"}
      aria-hidden={p["aria-hidden"] ?? true}
    >
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.3-4.3" />
    </svg>
  ),
  Close: (p: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={p.className ?? "w-4 h-4"}
      aria-hidden={p["aria-hidden"] ?? true}
    >
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  ),
};
